export const SET_ORDERS_MAX_DAYS_AGO = "SET_ORDERS_MAX_DAYS_AGO";
